export const getOrders = () => {
    return window.axios.get('/api/dashboard/getOrders');
}
